import type { PlgPermissionService } from '@/domains/shared/services/base-plg-permission-service';

/**
 * FTO模块编辑权限服务
 *
 * 用于判断当前用户是否有权限编辑FTO模块内容
 */
export interface FTOProPermissionService extends PlgPermissionService {}

export const FTOProPermissionService = Symbol.for('FTOProPermissionService');
